import Vue from "vue";
import VueRouter from "vue-router";
import LoginLayout from "@/layouts/Login";
import MainLayout from "@/layouts/Main";
import PublicLayout from "@/layouts/Public";
import AuthService from "@/services/auth";
import store from "@/store";

Vue.use(VueRouter);
Vue.use(AuthService);

const router = new VueRouter({
  base: process.env.VUE_APP_BASE_URL,
  mode: process.env.VUE_APP_ROUTER_MODE,
  routes: [
    {
      path: "/",
      redirect: "transactions",
      component: MainLayout,
      meta: { authRequired: true, hidden: true, breadcrumbName: "Home" },
      children: [
        // Dashboard pages
        {
          path: "/dashboard/alpha",
          component: () => import("./views/Dashboard/Alpha")
          //cuando es root o redirect se le pone breadcrumbName solo al parent
        },
        {
          path: "/customers",
          component: () => import("./views/Dashboard/Customers"),
          redirect: "",
          meta: { breadcrumbName: "Clientes" },
          children: [
            // Dashboard pages
            {
              path: "/",
              component: () => import("./views/Dashboard/Customers/List"),
              name: "customersList"
              //cuando es root se le pone breadcrumbName solo al parent
            },
            {
              path: ":id",
              component: () => import("./views/Dashboard/Customers/Details"),
              name: "customerDetails",
              meta: { breadcrumbName: ":id" }
            }
          ]
        },
        {
          path: "/subscriptions",
          component: () => import("./views/Dashboard/Subscriptions"),
          redirect: "",
          meta: { breadcrumbName: "Suscripciones" },
          children: [
            // Dashboard pages
            {
              path: "/",
              component: () =>
                import("./views/Dashboard/Subscriptions/SubscriptionsList"),
              name: "subscriptionsList"
              //cuando es root se le pone breadcrumbName solo al parent
            },
            {
              path: "add",
              component: () =>
                import("./views/Dashboard/Subscriptions/SubscriptionAddEdit"),
              name: "subscriptionDetailsAdd",
              meta: { breadcrumbName: "Nueva" }
            },
            {
              path: ":id",
              component: () =>
                import("./views/Dashboard/Subscriptions/SubscriptionDetails"),
              name: "subscriptionDetails",
              meta: { breadcrumbName: ":id" }
            },
            {
              path: ":id/edit",
              component: () =>
                import("./views/Dashboard/Subscriptions/SubscriptionAddEdit"),
              name: "subscriptionDetailsEdit",
              meta: { breadcrumbName: ":id Edición" }
            },
            {
              path: ":id/subscribers/add",
              component: () =>
                import("./views/Dashboard/Subscriptions/SubscriberAddEdit"),
              name: "subscriberAdd",
              meta: { breadcrumbName: ":id Nuevo Suscripto" }
            },
            {
              path: ":id/subscribers/:subscriberId/edit",
              component: () =>
                import("./views/Dashboard/Subscriptions/SubscriberAddEdit"),
              name: "subscriberEdit",
              meta: { breadcrumbName: ":id Editar Suscripto" }
            },
            {
              path: ":id/subscribers/:subscriberId",
              component: () =>
                import("./views/Dashboard/Subscriptions/SubscriberAddEdit"),
              name: "subscriberView",
              meta: { breadcrumbName: ":id Vista de Suscripto" }
            }
          ]
        },
        {
          path: "/payment-links",
          component: () => import("./views/Dashboard/PaymentLinks"),
          redirect: "",
          meta: { breadcrumbName: "Links de Pago" },
          children: [
            // Dashboard pages
            {
              path: "/",
              component: () => import("./views/Dashboard/PaymentLinks/List"),
              name: "paymentLinksList"
              //cuando es root se le pone breadcrumbName solo al parent
            },
            {
              path: "add",
              component: () => import("./views/Dashboard/PaymentLinks/AddEdit"),
              name: "paymentLinkAdd",
              meta: { breadcrumbName: "Nueva" }
            },
            {
              path: ":id",
              component: () => import("./views/Dashboard/PaymentLinks/Details"),
              name: "paymentLinkDetails",
              meta: { breadcrumbName: ":id" }
            },
            {
              path: ":id/edit",
              component: () => import("./views/Dashboard/PaymentLinks/AddEdit"),
              name: "paymentLinkEdit",
              meta: { breadcrumbName: ":id Edición" }
            },
            {
              path: ":id/sell",
              component: () => import("./views/Dashboard/PaymentLinks/Sell"),
              name: "paymentLinkSell",
              meta: { breadcrumbName: ":id Nuevo Cliente" }
            }
          ]
        },
        {
          path: "/transactions",
          component: () => import("./views/Dashboard/Transactions"),
          redirect: "",
          meta: { breadcrumbName: "Transacciones" },
          children: [
            // Dashboard pages
            {
              path: "/",
              component: () =>
                import("./views/Dashboard/Transactions/TransactionsList"),
              name: "transactionsList"
              //cuando es root se le pone breadcrumbName solo al parent
            },
            {
              path: ":id",
              component: () =>
                import("./views/Dashboard/Transactions/TransactionDetails"),
              name: "transactionDetails",
              meta: { breadcrumbName: ":id" }
            }
          ]
        },
        {
          path: "/admin/business-units",
          component: () => import("./views/Dashboard/Admin/BusinessUnits"),
          meta: { breadcrumbName: "Unidades de Negocio" }
        },
        {
          path: "/admin/products",
          component: () => import("./views/Dashboard/Admin/Products"),
          meta: { breadcrumbName: "Productos" }
        },
        {
          path: "/admin/cost-centers",
          component: () => import("./views/Dashboard/Admin/CostCenters"),
          meta: { breadcrumbName: "Centros de Costo" }
        },
        {
          path: "/admin/users",
          component: () => import("./views/Dashboard/Admin/Users"),
          meta: { breadcrumbName: "Usuarios" }
        },
        // AntDesign
        {
          path: "/antd",
          component: () => import("./views/Antd"),
          meta: { breadcrumbName: "Ant Design" }
        }
        // // 404
        // {
        //   path: "/404",
        //   component: () => import("./views/404"),
        //   meta: { breadcrumbName: "Página Inexistente" }
        // }
      ]
    },

    // Public Pages w/header
    {
      path: "/user",
      component: LoginLayout,
      redirect: "/user/login",
      children: [
        {
          path: "/user/login",
          name: "login",
          component: () => import("./views/Public/User/Login")
        },
        {
          path: "/user/forgot",
          component: () => import("./views/Public/User/Forgot")
        },
        {
          path: "/user/new-password/:token",
          component: () => import("./views/Public/User/NewPassword")
        }
      ]
    },

    // Public Pages w/o header
    {
      path: "/subscribe",
      component: PublicLayout,
      meta: { authRequired: false },
      //component: () => import("./views/Public/MembresiaForm")
      redirect: "/subscribe",
      children: [
        {
          path: "/subscribe",
          meta: { authRequired: false },
          component: () => import("./views/Public/MembresiaForm")
        }
      ]
    },
    {
      path: "/subscriber",
      component: PublicLayout,
      meta: { authRequired: false, AOLSkin: true },
      redirect: "/subscriber/:linkToken",
      children: [
        {
          path: "/subscriber/:linkToken",
          meta: {
            authRequired: false,
            AOLSkin: true,
            title: "El Arte de Vivir - Suscripciones"
          },
          component: () => import("./views/Public/SubscriptionLink")
        },
        {
          path: "/subscriber/edit/:linkToken",
          meta: {
            authRequired: false,
            AOLSkin: true,
            title: "El Arte de Vivir - Suscripciones"
          },
          component: () => import("./views/Public/SubscriberPaymentEditLink")
        }
      ]
    },
    //UNCOMMENT TO ENABLE PAYMENT LINKS
    {
      path: "/pay",
      component: PublicLayout,
      meta: { authRequired: false, AOLSkin: true },
      redirect: "/pay/:linkToken",
      children: [
        {
          path: "/pay/:linkToken",
          meta: {
            authRequired: false,
            AOLSkin: true,
            title: "El Arte de Vivir - Pagos"
          },
          component: () => import("./views/Public/PaymentLink")
        }
      ]
    },
    // 404
    {
      path: "/404",
      meta: { authRequired: false, AOLSkin: true },
      component: () => import("./views/404")
      //meta: { breadcrumbName: "Página Inexistente" }
    },
    // Redirect to 404
    {
      path: "*",
      redirect: "/404",
      hidden: true
    }
  ]
});

//global navigation guard
//esta funcion especial de vue usa next para correr distintos filtros. La idea es que no hay un next despues de otro en una secuencia, es decir que el codigo no permita correr más de uno.
router.beforeEach((to, from, next) => {
  //auth required
  if (to.matched.some(record => record.meta && record.meta.authRequired)) {
    if (Vue.prototype.$auth.isAuthenticated()) {
      if (to.matched.some(record => record.meta && !record.meta.AOLSkin)) {
        document.title = "Portal de Pagos";
        document.querySelector("link[rel*='icon'], link[sizes='32x32']").href =
          "./favicon-hoa.png";
        document.querySelector("link[rel*='icon'], link[sizes='16x16']").href =
          "./favicon-hoa.png";
        //next();
      }
      next();
    } else {
      next({
        path: "/user/login",
        query: { redirect: to.fullPath }
      });
    }
  } else {
    //auth not required
    const fields = to.matched
      .slice()
      .reverse()
      .find(r => r.meta && r.meta.title);
    if (fields && fields.meta.title) document.title = fields.meta.title;
    next();
  }
});

export default router;
